import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule, MatToolbarModule, MatSidenavModule, MatListModule, MatDatepickerModule, MatTabsModule, MatExpansionModule, MatTooltipModule } from '@angular/material';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GridComponent } from './grid/grid.component';
import { ModalComponent } from './modal/modal.component';
import { MessageBoxComponent } from './message-box.component';
import { TreelistComponent } from './treelist/treelist.component';
import { GridRowButtonsComponent } from './grid/grid-row-buttons/grid-row-buttons.component';
import { GridCheckboxFilterComponent } from './grid/grid-checkbox-filter/grid-checkbox-filter.component';
import { GridHeaderComponent } from './grid/grid-header/grid-header.component';
import { TreelistElementComponent } from './treelist/treelist-element/treelist-element.component';
import { TranslatorService } from '../translator/translator.service';
//import { LayoutModule } from '../../layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedTemplateModule } from '../../shared-template/shared-template.module';
import { RouterModule } from '@angular/router';
import { Ng2TableModule } from 'ng2-table';
import { DateInputComponent } from './date-input/date-input.component';
import { RichTextComponent } from './richtext/richtext.component';
import { UserNoteRest } from './richtext/usernote.rest';
import { NgxSelectModule } from 'ngx-select-ex';
import { AttachmentsComponent } from './attachments/attachments.component';
import { EmployeeModalComponent } from '../../company/employees/employee-modal/employee-modal.component';
import { TabMenuComponent } from './tabmenu/tabmenu.component';
import { NumeratorModule } from '../../numerator/numerator.module';
import { NumeratorComponent } from '../../numerator/numerator.component';
import { NgxNumberSpinModule } from 'ngx-number-spin';
import { SpinEditComponent } from './spinedit/spinedit.component';
import { ReadonlyDirective } from './grid/readonly-checkbox.directive';
import { DeleteCommaPipe } from './spinedit/delete-comma-pipe.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NumeratorRest } from '../../numerator/numerator.rest';
import { InputFocusDirective } from './input-focus.directive';
import { IfNanPipe } from './grid/if-nan.filter';
import { ContextMenuModule } from 'ngx-contextmenu';
import { ItemSelectionComponent } from './item-selection/item-selection.component';
import { DndModule } from 'ngx-drag-drop';
import { ColumnEditorComponent } from './grid/column-editor/column-editor.component';
import { DialogComponent } from './dialog/dialog.component';
import { DialogChildInsertionDirective } from './dialog/dialog-directive';
import { DialogService } from './dialog/dialog.service';
import { GridRest } from './grid/grid.rest';
import { CalendarComponent } from './calendar/calendar.component';
import { ResizableModule } from 'angular-resizable-element';
import { ResizableDirective } from './resizable.directive';
import { CustomersRest } from '../../company/customers/customers.rest';
import { EmployeeIdSelectionComponent } from './employee-selection/employee-id-selection.component';

@NgModule({
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule,
      RouterModule,
      SharedTemplateModule,
      Ng2TableModule,
      NgxSelectModule,
      NgxNumberSpinModule,
      PaginationModule,
      ResizableModule,
      ContextMenuModule.forRoot({
         useBootstrap4: true
      }),
      DndModule
   ],
   declarations: [
      GridComponent,
      GridRowButtonsComponent,
      GridHeaderComponent,
      GridCheckboxFilterComponent,
      ModalComponent,
      MessageBoxComponent,
      TreelistComponent,
      TreelistElementComponent,
      DateInputComponent,
      RichTextComponent,
      AttachmentsComponent,
      EmployeeModalComponent,
      TabMenuComponent,
      SpinEditComponent,
      NumeratorComponent,
      DeleteCommaPipe,
      ReadonlyDirective,
      InputFocusDirective,
      IfNanPipe,
      ItemSelectionComponent,
      ColumnEditorComponent,
      DialogComponent,
      DialogChildInsertionDirective,
      CalendarComponent,
      ResizableDirective,
      EmployeeIdSelectionComponent
   ],
   exports: [
      MatToolbarModule,
      MatIconModule,
      MatListModule,
      MatSidenavModule,
      MatMenuModule,
      MatCheckboxModule,
      MatDatepickerModule,
      MatTabsModule,
      MatExpansionModule,
      DatepickerModule,
      TimepickerModule,
      AlertModule,
      ReactiveFormsModule,
      CommonModule,
      FormsModule,
      GridComponent,
      ModalComponent,
      MessageBoxComponent,
      BsDropdownModule,
      TreelistComponent,
      //LayoutModule,
      TranslateModule,
      SharedTemplateModule,
      RouterModule,
      Ng2TableModule,
      DateInputComponent,
      RichTextComponent,
      NgxSelectModule,
      AttachmentsComponent,
      EmployeeModalComponent,
      TabMenuComponent,
      //NumeratorModule,
      SpinEditComponent,
      NumeratorComponent,
      NgxNumberSpinModule,
      ReadonlyDirective,
      PaginationModule,
      InputFocusDirective,
      CalendarComponent,
      ResizableModule,
      ResizableDirective,
      MatTooltipModule,
      EmployeeIdSelectionComponent
   ],
   entryComponents: [DialogComponent, ColumnEditorComponent],
   providers: [
      UserNoteRest,
      NumeratorRest,
      DialogService,
      GridRest,
      CustomersRest
   ]
})
export class SharedModule { }
